import * as actionTypes from 'containers/PageHeader/action-types';
import { FilterSelectionType, GlobalFilterKeyType, SelectionType } from 'utils/types';

export const clearGlobalFilter = (globalFilterKey: GlobalFilterKeyType) => ({
  type: actionTypes.GLOBAL_FILTER_CLEAR,
  payload: globalFilterKey
});

export const clearGlobalFilterForType = (
  globalFilterKey: GlobalFilterKeyType,
  type: SelectionType
) => ({
  type: actionTypes.GLOBAL_FILTER_FOR_TYPE_CLEAR,
  payload: { globalFilterKey, type }
});

export const removeGlobalFilterItem = (
  globalFilterKey: GlobalFilterKeyType,
  type: string,
  id: string
) => ({
  type: actionTypes.GLOBAL_FILTER_ITEM_REMOVE,
  payload: { globalFilterKey, type, id }
});

export const updateGlobalFilterArray = (
  newArray: Array<string>,
  arrayName: string,
  globalFilterKey: GlobalFilterKeyType
) => ({
  type: actionTypes.GLOBAL_FILTER_ARRAY_UPDATE,
  payload: { newArray, arrayName, globalFilterKey }
});

export const updateGlobalFilterArrays = (
  newFilter: FilterSelectionType,
  globalFilterKey: GlobalFilterKeyType
) => ({
  type: actionTypes.GLOBAL_FILTER_ARRAYS_UPDATE,
  payload: { newFilter, globalFilterKey }
});

export const updateGlobalFilterWeeks = (weeks: number) => ({
  type: actionTypes.GLOBAL_FILTER_WEEKS_UPDATE,
  payload: weeks
});

export const updateGlobalFilterBrand = (brand: string) => ({
  type: actionTypes.GLOBAL_FILTER_BRAND_UPDATE,
  payload: brand
});
